import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import html2pdf from 'html2pdf.js';
// import cisceLogo from '../../img/cisce.png';
import { QRCodeSVG } from 'qrcode.react'; // Import QRCodeSVG

// small helpers
const toNumber = (v) => {
  if (v === null || v === undefined || v === '') return null;
  const n = Number(v);
  return Number.isFinite(n) ? n : null;
};

// Regn. Id. formatter – same pattern as ResultPage (19AU4433 → 19-AU-4433)
const formatRegnIdNice = (id) => {
  if (!id) return 'N/A';
  const s = String(id).replace(/\s+/g, '');
  if (s.length <= 4) return s;
  const part1 = s.slice(0, 2);
  const part2 = s.slice(2, 4);
  const part3 = s.slice(4);
  return `${part1}-${part2}-${part3}`;
};

// Roll No: remove slash + spaces if present
const formatRollNo = (roll) => {
  if (!roll) return 'N/A';
  return String(roll).replace(/[\/\s]/g, '');
};

// number → words (same as ResultPage, UPPERCASE)
const numberToWords = (num) => {
  if (!Number.isFinite(num)) return '';
  if (num === 0) return 'ZERO';

  const belowTwenty = [
    '', 'ONE', 'TWO', 'THREE', 'FOUR', 'FIVE', 'SIX', 'SEVEN', 'EIGHT', 'NINE',
    'TEN', 'ELEVEN', 'TWELVE', 'THIRTEEN', 'FOURTEEN', 'FIFTEEN', 'SIXTEEN',
    'SEVENTEEN', 'EIGHTEEN', 'NINETEEN',
  ];
  const tens = [
    '', '', 'TWENTY', 'THIRTY', 'FORTY', 'FIFTY', 'SIXTY', 'SEVENTY', 'EIGHTY',
    'NINETY',
  ];
  const scales = ['', 'THOUSAND', 'MILLION', 'BILLION'];

  const toWordsUnderThousand = (n) => {
    let str = '';
    if (n >= 100) {
      const h = Math.floor(n / 100);
      str += belowTwenty[h] + ' HUNDRED';
      n = n % 100;
      if (n > 0) str += ' ';
    }
    if (n >= 20) {
      const t = Math.floor(n / 10);
      str += tens[t];
      const r = n % 10;
      if (r > 0) str += ' ' + belowTwenty[r];
    } else if (n > 0) {
      str += belowTwenty[n];
    }
    return str;
  };

  let n = Math.floor(num);
  let scaleIndex = 0;
  const parts = [];

  while (n > 0 && scaleIndex < scales.length) {
    const chunk = n % 1000;
    if (chunk > 0) {
      let chunkWords = toWordsUnderThousand(chunk);
      if (scales[scaleIndex]) {
        chunkWords += ' ' + scales[scaleIndex];
      }
      parts.unshift(chunkWords);
    }
    n = Math.floor(n / 1000);
    scaleIndex++;
  }

  return parts.join(' ').trim();
}; 

const DigiLockerResultPage = () => {
  const API_BASE_URL = 'https://peakybalvinder.pythonanywhere.com/api/mdu';
  // const API_BASE_URL = 'http://127.0.0.1:5001/api/mdu';
  const navigate = useNavigate();
  const location = useLocation();

  const [indexNo, setIndexNo] = useState(null);
  const [studentData, setStudentData] = useState(null);
  const [semester, setSemester] = useState(null); 
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showDigiLockerBlock, setShowDigiLockerBlock] = useState(true);

  // useEffect(() => {
  //   let currentId = null;
  //   let urlRollId = null;

  //   if (location.state && location.state.indexNo) {
  //     currentId = location.state.indexNo;
  //     console.log("ResultPage: IndexNo found in location.state:", currentId);
  //   } else {
  //     currentId = localStorage.getItem('digiLockerRollId');
  //     if (currentId) {
  //       console.log("ResultPage: IndexNo found in localStorage:", currentId);
  //     } else {
  //       console.log("ResultPage: No indexNo found in location.state or localStorage.", currentId);
  //     }

  //     const params = new URLSearchParams(window.location.search);
  //     urlRollId = params.get('rollid');

  //     if (urlRollId === null || urlRollId.trim() === '') {
  //       console.warn("⚠️ rollId is missing or empty.");
  //     } else {
  //       console.log("✅ Got rollId:", urlRollId);
  //       currentId = urlRollId;
  //     }
  //   }

  //   setShowDigiLockerBlock(!urlRollId);
  //   setIndexNo(currentId);

  //   if (!currentId) {
  //     setError("No result found! Please check your Course/UID/Index number and try again.");
  //     setLoading(false);
  //     return;
  //   }

  //   const fetchStudent = async () => {
  //     setLoading(true);
  //     setError(null);
  //     try {
  //       const response = await fetch(`${API_BASE_URL}/public/students/${currentId}`, {
  //         method: 'GET',
  //         headers: {
  //           'Content-Type': 'application/json',
  //         },
  //       });

  //       if (!response.ok) {
  //         const errorData = await response.json();
  //         if (response.status === 404) {
  //           throw new Error("Result not found for this Index Number.");
  //         }
  //         throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
  //       }
  //       const data = await response.json();
  //       setStudentData(data);
  //     } catch (err) {
  //       console.error('Error fetching student for Result Page:', err);
  //       setError(err.message || 'Failed to load student data.');
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   fetchStudent();
  // }, [location.state, navigate]);

  useEffect(() => {
  let currentId = null;
  let currentSem = null;
  let urlRollId = null;

  

  // 1️⃣ Read from URL (?rollid=...&semester=...)
  const params = new URLSearchParams(window.location.search);
  urlRollId = params.get('rollid');
  const urlSem = params.get('semester');

  // 2️⃣ Priority: location.state (when you click "View DigiLocker" from dashboard)
  if (location.state && location.state.indexNo) {
    currentId = location.state.indexNo;
    currentSem = location.state.semester || urlSem || null;
    console.log('DigiLocker: from location.state →', currentId, 'sem:', currentSem);
  } else {
    // 3️⃣ Fallback: localStorage
    const lsId = localStorage.getItem('digiLockerRollId');
    const lsSem = localStorage.getItem('digiSemester'); // if you ever store it

    if (lsId) {
      currentId = lsId;
      currentSem = lsSem || urlSem || null;
      console.log('DigiLocker: from localStorage →', currentId, 'sem:', currentSem);
    } else if (urlRollId) {
      // 4️⃣ Fallback: pure URL rollid (QR / external link)
      currentId = urlRollId;
      currentSem = urlSem || null;
      console.log('DigiLocker: from URL rollid →', currentId, 'sem:', currentSem);
    } else {
      console.log('DigiLocker: No indexNo found in state, localStorage or URL.');
    }
  }

  // Show DigiLocker block only when NOT opened via external rollid (keep your previous logic)
  setShowDigiLockerBlock(!urlRollId);

  setIndexNo(currentId);
  setSemester(currentSem);

  if (!currentId) {
    setError(
      'No result found! Please check your Course/UID/Index number and try again.'
    );
    setLoading(false);
    return;
  }

  const fetchStudent = async () => {
    setLoading(true);
    setError(null);
    try {
      let url;
      // 🔥 KEY PART: if we know semester → use indexNo+semester API
      if (currentId && currentSem) {
        url = `${API_BASE_URL}/public/students?indexNo=${encodeURIComponent(
          currentId
        )}&semester=${encodeURIComponent(currentSem)}`;
      } else {
        // no semester → highest semester (4th etc.)
        url = `${API_BASE_URL}/public/students/${currentId}`;
      }

      console.log('DigiLocker: fetching URL →', url);

      const response = await fetch(url, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        if (response.status === 404) {
          throw new Error('Result not found for this Index Number / semester.');
        }
        throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      setStudentData(data);
    } catch (err) {
      console.error('Error fetching student for DigiLocker Page:', err);
      setError(err.message || 'Failed to load student data.');
    } finally {
      setLoading(false);
    }
  };

  fetchStudent();
// re-run if location.state changes
}, [location.state]);

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    try {
      const date = new Date(dateString);
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      return `${day}-${month}-${year}`;
    } catch (e) {
      return 'Invalid Date';
    }
  };

  const downloadPdf = () => {
    const element = document.getElementById('result-content');

    if (element) {
      const originalOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';

      const opt = {
        margin: 0,
        filename: `Result_${studentData.candidateName.replace(/\s/g, '_')}_${studentData.indexNo}.pdf`,
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: {
          scale: 4,
          logging: true,
          dpi: 600,
          letterRendering: true,
          useCORS: true,
          windowWidth: element.scrollWidth,
          windowHeight: element.scrollHeight,
          width: element.offsetWidth,
        },
        jsPDF: {
          unit: 'mm',
          format: [209.9, 297.1],
          orientation: 'portrait'
        }
      };

      html2pdf().set(opt).from(element).save().then(() => {
        document.body.style.overflow = originalOverflow;
      });
    } else {
      console.error('Could not find element with ID "result-content" for PDF conversion.');
    }
  };

  const getCurrentFormattedTimestamp = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-screen bg-gray-100">
        <p className="text-xl text-blue-600">Loading student result...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex flex-col justify-center items-center min-h-screen bg-gray-100 p-4">
        <p className="text-xl text-red-600 mb-4">Error: {error}</p>
        <button
          className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-6 rounded-lg transition duration-300"
        >
          Try Again!!!
        </button>
      </div>
    );
  }

  if (!studentData) {
    return (
      <div className="text-center py-10 text-gray-500 text-lg min-h-screen flex flex-col items-center justify-center bg-gray-100 p-4">
        <p className="mb-4">No student data found for the provided ID.</p>
        <button
          className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-6 rounded-lg transition duration-300"
        >
          Try Again!!!</button>
      </div>
    );
  }

  // ---------- derived stuff ----------

  const courseName =
    studentData.course ||
    (studentData.classSelected
      ? String(studentData.classSelected).split(' - ')[0]
      : '') ||
    '';


let motherName = '';
  let fatherName = '';
  if (studentData.sonOf) {
    const parts = String(studentData.sonOf).split('\n');
    motherName = (parts[0] || '').trim();
    fatherName = (parts[1] || '').trim() || motherName;
  }
  




  const sonLines = studentData.sonOf?.toUpperCase().split('\n') || [];
  const motherRaw =
    sonLines.find((line) => line.startsWith('SMT'))?.replace('SMT', '').trim() ||
    '';
  const fatherRaw =
    sonLines.find((line) => line.startsWith('SHRI'))?.replace('SHRI', '').trim() ||
    '';

  const rawSubjects = (studentData.subjects || []).filter(
    (s) => s.subjectName || s.name
  );


  const rawFinalFlag =
  studentData.isFinalSemester ?? studentData.is_final_semester ?? false;

const isFinalSemester =
  rawFinalFlag === true ||
  rawFinalFlag === 'true' ||
  rawFinalFlag === 1 ||
  rawFinalFlag === '1';


  // // same flag logic as ResultPage
  // const isFinalSemester =
  //   studentData.isFinalSemester ?? studentData.is_final_semester ?? false;

  // same names as ResultPage
  const previousYearTotalObtained =
    toNumber(studentData.previous_year_obtained_total) || 0;

  const previousYearMaxTotal =
    toNumber(studentData.previousYearMaxTotal ?? studentData.previousYearTotal) ||
    null;

  const normalizedSubjects = rawSubjects.map((sub) => {
    const subjectName = sub.subjectName || sub.name || '';
    const subjectCode = sub.subjectCode || sub.code || '';

    const external =
      toNumber(sub.theory) ??
      toNumber(sub.theoryMarks) ??
      toNumber(sub.externalMarks);

    const internal =
      toNumber(sub.practical) ??
      toNumber(sub.practicalMarks) ??
      toNumber(sub.internalMarks);

    const minExternal =
      toNumber(sub.minExternalMarks) ??
      toNumber(sub.min_external_marks);

    const minInternal =
      toNumber(sub.minInternalMarks) ??
      toNumber(sub.min_internal_marks);

    const maxExternal =
      toNumber(sub.maxExternalMarks) ??
      toNumber(sub.max_external_marks) ??
      80;

    const maxInternal =
      toNumber(sub.maxInternalMarks) ??
      toNumber(sub.max_internal_marks) ??
      20;

    return {
      subjectName,
      subjectCode,
      external,
      internal,
      minExternal,
      minInternal,
      maxExternal,
      maxInternal,
    };
  });

  let totalExternalObtained = 0;
  let totalInternalObtained = 0;
  let totalMaxExternal = 0;
  let totalMaxInternal = 0;

  const tableRows = normalizedSubjects.map((row, idx) => {
    const ext = toNumber(row.external);
    const int = toNumber(row.internal);
    const minExt = toNumber(row.minExternal);
    const minInt = toNumber(row.minInternal);
    const maxExt = toNumber(row.maxExternal);
    const maxInt = toNumber(row.maxInternal);

    const totalObtained =
      (ext != null ? ext : 0) + (int != null ? int : 0);
    const hasObtained = ext != null || int != null;

    const minTotal =
      (minExt != null ? minExt : 0) + (minInt != null ? minInt : 0);
    const hasMin = minExt != null || minInt != null;

    const maxTotal =
      (maxExt != null ? maxExt : 0) + (maxInt != null ? maxInt : 0);
    const hasMax = maxExt != null || maxInt != null;

    if (hasObtained) {
      totalExternalObtained += ext != null ? ext : 0;
      totalInternalObtained += int != null ? int : 0;
    }
    if (hasMax) {
      totalMaxExternal += maxExt != null ? maxExt : 0;
      totalMaxInternal += maxInt != null ? maxInt : 0;
    }

    return {
      index: idx,
      subjectLabel:
        row.subjectCode || row.subjectName
          ? `${row.subjectCode || ''}${
              row.subjectCode && row.subjectName ? '  ' : ''
            }${row.subjectName || ''}`
          : '',
      ext,
      int,
      totalObtained: hasObtained ? totalObtained : null,
      minExt,
      minTotal: hasMin ? minTotal : null,
      maxExt,
      maxInt,
      maxTotal: hasMax ? maxTotal : null,
    };
  });

  const grandObtainedCurrent = totalExternalObtained + totalInternalObtained;
  const grandMaxCurrent = totalMaxExternal + totalMaxInternal;

  const grandObtainedAll = isFinalSemester
    ? grandObtainedCurrent + previousYearTotalObtained
    : grandObtainedCurrent;

  const grandMaxAll =
    isFinalSemester && previousYearMaxTotal != null
      ? grandMaxCurrent + previousYearMaxTotal
      : grandMaxCurrent;

  // result line exactly like ResultPage
  const numericForResult = isFinalSemester ? grandObtainedAll : grandObtainedCurrent;

  let resultLine;
  if (numericForResult && numericForResult > 0) {
    const words = numberToWords(numericForResult);
    resultLine = `PASSED AND HAS OBTAINED ${words} MARKS`;
  } else {
    const resultUpper = (studentData.result || '').toUpperCase();
    resultLine = resultUpper || 'RESULT NOT DECLARED';
  }

  return (
    <div className="flex flex-col items-center min-h-screen font-sans text-gray-800 py-8 bg-gray-50">

      {/* Main content container - same width / look */}
      <div
        id="result-content"
        className="bg-white mx-auto px-10 py-8 relative shadow-lg border border-gray-200 text-[13.5px] leading-relaxed"
        style={{ width: '793px' }}
      >

        {/* Header Section */}
        <div className="flex flex-col items-center mb-0">
          <div className="text-center mt-2">
            <p className="text-xl font-semibold uppercase leading-tight">
              MAHARSHI DAYANAND UNIVERSITY, ROHTAK
            </p>
            <p className="text-[18px] font-semibold uppercase tracking-wide leading-snug mt-1">
              {(courseName ? courseName.toUpperCase() : 'COURSE')} - {studentData.resultYear} Marksheet
            </p>
            <p className="text-[17px] font-semibold uppercase tracking-wide leading-snug mt-1">
              RESULT-cum-DETAILED MARKS CARD
            </p>
          </div>
        </div>

        {/* Candidate Details Section */}
        <div className="border-gray-300 py-3 mb-4 text-[13.5px] mt-4">
          <div className="grid grid-cols-2 gap-x-12 gap-y-1">
            <div>
              <div className="grid grid-cols-[auto_1fr] gap-x-2 gap-y-1">
                <div className="font-bold">Name :</div>
                <div className="font-normal">
                  {studentData.candidateName.toUpperCase() || 'N/A'}
                </div>

                <div className="font-bold">Regn. Id. :</div>
                <div className="font-normal">
                  {formatRegnIdNice(studentData.indexNo)}
                </div>

                

                <div className="font-bold">Mother&apos;s Name :</div>
                <div className="font-normal">
                  {motherName ? `SMT. ${motherName.toUpperCase()}` : 'N/A'}
                </div>
              </div>
            </div>

            <div>
              <div className="grid grid-cols-[auto_1fr] gap-x-2 gap-y-1">
                {studentData.dob && studentData.classSelected === 'Class X' && (
                  <>
                    <div className="font-bold">Date of Birth :</div>
                    <div className="font-normal">
                      {formatDate(studentData.dob)}
                    </div>
                  </>
                )}

                <div className="font-bold">Roll No. :</div>
                <div className="font-normal">
                  {formatRollNo(studentData.candidateId)}
                </div>
                <div className="font-bold">Father&apos;s Name :</div>
                <div className="font-normal">
                  {fatherName ? `SHRI ${fatherName.toUpperCase()}` : 'N/A'}
                </div>  
              
              </div>
            </div>
          </div>
        </div>

        {/* Subjects and Marks Table – same UI as before, only totals logic changed */}
        <div className="mb-1" style={{ border: '1px solid black' }}>
          <table className="w-full text-left table-fixed">
            <thead>
              <tr style={{ borderBottom: '1px solid black' }}>
                <th
                  className="py-2 px-3 text-sm font-bold w-[10%]"
                  style={{ borderRight: '1px solid black' }}
                >
                  Sr. No.
                </th>
                <th
                  className="py-2 px-3 text-sm font-bold w-[40%]"
                  style={{ borderRight: '1px solid black' }}
                >
                  Subject
                </th>
                <th
                  className="py-2 px-3 text-sm font-bold text-left w-[20%]"
                  style={{ borderRight: '1px solid black' }}
                >
                  Marks Obtained
                </th>
                <th
                  className="py-2 px-3 text-sm font-bold text-left w-[15%]"
                  style={{ borderRight: '1px solid black' }}
                >
                  Minimum Pass Marks
                </th>
                <th className="py-2 px-3 text-sm font-bold text-left w-[15%]">
                  Maximum Marks
                </th>
              </tr>
            </thead>
            <tbody>
              {tableRows.length > 0 ? (
                <>
                  {tableRows.map((row, index) => (
                    <tr
                      key={index}
                      style={{
                        borderBottom:
                          index === tableRows.length - 1
                            ? 'none'
                            : '1px solid black',
                      }}
                    >
                      <td
                        className="py-1.5 px-3 text-[13px] w-[10%]"
                        style={{ borderRight: '1px solid black' }}
                      >
                        {index + 1}
                      </td>

                      <td
                        className="py-1.5 px-3 text-[13px] w-[40%]"
                        style={{ borderRight: '1px solid black' }}
                      >
                        {row.subjectLabel || '\u00A0'}
                      </td>

                      {/* Marks Obtained */}
                      <td
                        className="py-1.5 px-3 text-[13px] w-[20%]"
                        style={{ borderRight: '1px solid black' }}
                      >
                        <div className="grid grid-cols-[1.6fr_1fr] grid-rows-2 gap-x-1">
                          <div className="text-[11px]">
                            {row.ext != null ? row.ext : '\u00A0'}
                          </div>
                          <div className="row-span-2 flex items-end justify-end text-[12px]">
                            {row.totalObtained != null
                              ? row.totalObtained
                              : '\u00A0'}
                          </div>
                          <div className="text-[11px] mt-0.5">
                            {row.int != null ? row.int : '\u00A0'}
                          </div>
                        </div>
                      </td>

                      {/* Minimum Pass Marks */}
                      <td
                        className="py-1.5 px-3 text-[13px] w-[15%]"
                        style={{ borderRight: '1px solid black' }}
                      >
                        <div className="grid grid-cols-[1.6fr_1fr] grid-rows-2 gap-x-1">
                          <div className="text-[11px]">
                            {row.minExt != null ? row.minExt : '\u00A0'}
                          </div>
                          <div className="row-span-2 flex items-end justify-end text-[12px]">
                            {row.minTotal != null ? row.minTotal : '\u00A0'}
                          </div>
                          <div className="text-[11px] mt-0.5">
                            &nbsp;
                          </div>
                        </div>
                      </td>

                      {/* Maximum Marks */}
                      <td className="py-1.5 px-3 text-[13px] w-[15%]">
                        <div className="grid grid-cols-[1.6fr_1fr] grid-rows-2 gap-x-1">
                          <div className="text-[11px]">
                            {row.maxExt != null
                              ? `${row.maxExt}T`
                              : '\u00A0'}
                          </div>
                          <div className="row-span-2 flex items-end justify-end text-[12px]">
                            {row.maxTotal != null ? row.maxTotal : '\u00A0'}
                          </div>
                          <div className="text-[11px] mt-0.5">
                            {row.maxInt != null
                              ? `${row.maxInt}S`
                              : '\u00A0'}
                          </div>
                        </div>
                      </td>
                    </tr>
                  ))}

                  {/* ✅ EXACT FUNCTIONALITY COPY FROM RESULT PAGE */}

                  {/* Non–final semester → only TOTAL row */}
{tableRows.length > 0 && !isFinalSemester && (
  <tr
    style={{
      borderTop: '1px solid black',
    }}
  >
    <td
      className="py-1.5 px-3 text-[13px]"
      style={{ borderRight: '1px solid black' }}
    ></td>
    <td
      className="py-1.5 px-3 text-[13px] font-bold"
      style={{ borderRight: '1px solid black' }}
    >
      TOTAL
    </td>
    <td
      className="py-1.5 px-3 text-[13px] text-center"
      style={{ borderRight: '1px solid black' }}
    >
      {grandObtainedCurrent}
    </td>
    <td
      className="py-1.5 px-3 text-[13px]"
      style={{ borderRight: '1px solid black' }}
    >
      &nbsp;
    </td>
    <td className="py-1.5 px-3 text-[13px] text-center">
      {grandMaxCurrent}
    </td>
  </tr>
)}

{/* Final semester → Total / Previous total / Grand total */}
{tableRows.length > 0 && isFinalSemester && (
  <tr
    style={{
      borderTop: '1px solid black',
    }}
  >
    <td
      className="py-1.5 px-3 text-[13px]"
      style={{ borderRight: '1px solid black' }}
    ></td>
    <td
      className="py-1.5 px-3 text-[13px]"
      style={{ borderRight: '1px solid black' }}
    >
      <div className="flex flex-col gap-0.5 text-[12px] font-bold">
        <span>Total</span>
        <span>Previous total</span>
        <span>Grand total</span>
      </div>
    </td>
    {/* Marks obtained column */}
    <td
      className="py-1.5 px-3 text-[13px]"
      style={{ borderRight: '1px solid black' }}
    >
      <div className="flex flex-col items-center gap-0.5 text-[12px]">
        <span>{grandObtainedCurrent}</span>
        <span>{previousYearTotalObtained}</span>
        <span>{grandObtainedAll}</span>
      </div>
    </td>
    {/* Minimum pass marks blank */}
    <td
      className="py-1.5 px-3 text-[13px]"
      style={{ borderRight: '1px solid black' }}
    >
      &nbsp;
    </td>
    {/* Maximum marks column */}
    <td className="py-1.5 px-3 text-[13px]">
      <div className="flex flex-col items-center gap-0.5 text-[12px]">
        <span>{grandMaxCurrent}</span>
        <span>
          {previousYearMaxTotal != null ? previousYearMaxTotal : 'N/A'}
        </span>
        <span>{grandMaxAll}</span>
      </div>
    </td>
  </tr>
)}
                </>
              ) : (
                <tr>
                  <td colSpan="5" className="p-4 text-center text-gray-500">
                    No subject data available.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Result line – same logic as ResultPage */}
        <div className="grid grid-cols-[auto_1fr] text-[15.5px] mb-2">
          <div className="py-1 px-3 font-bold text-left">
            Result: {resultLine}
          </div>
        </div>

        {/* QR / seal / box + notes below – unchanged */}
        {showDigiLockerBlock && (
          <div className="border border-gray-400 p-4 mt-6">
            <div
              className="grid gap-x-6 items-end mx-auto"
              style={{ gridTemplateColumns: '120px 300px 180px' }}
            >
              <div className="flex flex-col justify-center items-center h-[120px] w-[120px] bg-white p-1">
                {studentData.indexNo ? (
                  <>
                    {/* <QRCodeSVG
                      value={`https://digilocker.mduedu.org/?rollid=${encodeURIComponent(
                        studentData.indexNo
                      )}`}
                      size={100}
                      level="H"
                    /> */}
                    <QRCodeSVG
                      value={`https://digilocker.mduedu.org/?rollid=${encodeURIComponent(
                        studentData.indexNo
                      )}${
                        studentData.semester
                          ? `&semester=${encodeURIComponent(studentData.semester)}`
                          : ''
                      }`}
                      size={100}
                      level="H"
                    />
                  </>
                ) : (
                  <div className="text-[10px] text-gray-500 text-center">
                    QR Not Available
                  </div>
                )}
              </div>

              <div className="flex justify-center items-end h-[120px]">
                <img
                  src="https://digilocker.cisceboard.org/assets/nad_verified.png"
                  alt="Verification Seal"
                  className="max-h-[100px] object-contain w-auto"
                />
              </div>

              <div className="relative flex flex-col justify-start h_[150px] w-[220px] text-[10px] leading-snug border border-gray-500 p-2">
                <div className="flex items-center mb-0.5">
                  <p className="font-bold mr-1">Digitally signed by</p>
                  <img
                    src="https://digilocker.cisceboard.org/assets/verified.png"
                    alt="Verified Seal"
                    className="object-contain max-h-[25px]"
                  />
                </div>
                <p className="mb-0.5">MAHARSHI DAYANAND</p>
                <p className="uppercase mb-0.5">
                   UNIVERSITY
                </p>
                <p className="font-bold">Date: {getCurrentFormattedTimestamp()}</p>
              </div>
            </div>
          </div>
        )}

        {showDigiLockerBlock ? (
          <div className="text-[10px] text-gray-700 leading-snug space-y-1.5 px-1 mt-7">
            <p className="font-bold">Note :-</p>
            <ol className="list-decimal pl-5 space-y-0.5">
              <li>This mark sheet is generated by DigiLocker directly from MDU&apos;s database.</li>
              <li>It is a legally valid digitally signed document as per the IT Act 2000 when used electronically.</li>
              <li>To verify the mark sheet, one can download the DigiLocker Android application and scan the QR code on the mark sheet.</li>
              <li>Abbreviations used include: AB-Absent, EX-Exempted, FP-Fail in Practical, FT-Fail in Theory.</li>
            </ol>
          </div>
        ) : (
          <div className="text-[10px] text-gray-700 leading-snug space-y-1.5 px-1 mt-7">
            <p className="font-bold">Disclaimer</p>
            <p className="text-left">
              All information on this print is provided free of cost for personal perusal only, 
              and as such, is made available "AS IS". Every effort has been made to ensure accuracy of 
              the data on this print. However, MDU does not make any claim about the accuracy or validity of the 
              content on this print, or its suitability for any specific purpose whatsoever, whether express or implied. 
              MDU will not be responsible for any errors or omissions on this Web print. 
              In particular but without being limited thereto, MDU disclaims any responsibility 
              for typographical errors and other inaccuracies that may be contained within the print.
               Those users who access information on this Print have done so voluntarily of their own accord,
                any outcome (decision or claim) of such access is understood to be their sole sole responsibility. 
                MDU reserves the right to make changes to this information and print without notice.
            </p>
          </div>
        )}
      </div>

      {/* Print button remains commented out as before */}
    </div>
  );
};

export default DigiLockerResultPage;